import React from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import WidgetsRoundedIcon from '@mui/icons-material/WidgetsRounded';
import InsertDriveFileRoundedIcon from '@mui/icons-material/InsertDriveFileRounded';
import LayersRoundedIcon from '@mui/icons-material/LayersRounded';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import PaletteRoundedIcon from '@mui/icons-material/PaletteRounded';
import DashboardCustomizeRoundedIcon from '@mui/icons-material/DashboardCustomizeRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';

export const BUILDER_SIDEBAR_VIEWS = Object.freeze({
  ELEMENTS: 'elements',
  PAGES: 'pages',
  LAYERS: 'layers',
  INSPECTOR: 'inspector',
  GLOBAL_STYLES: 'global-styles',
  TEMPLATES: 'templates',
  SETTINGS: 'settings',
});

const ITEMS = [
  { key: BUILDER_SIDEBAR_VIEWS.ELEMENTS, label: 'Add', icon: WidgetsRoundedIcon },
  { key: BUILDER_SIDEBAR_VIEWS.PAGES, label: 'Pages', icon: InsertDriveFileRoundedIcon },
  { key: BUILDER_SIDEBAR_VIEWS.LAYERS, label: 'Page Structure', icon: LayersRoundedIcon },
  { key: BUILDER_SIDEBAR_VIEWS.INSPECTOR, label: 'Edit', icon: TuneRoundedIcon },
  { key: BUILDER_SIDEBAR_VIEWS.GLOBAL_STYLES, label: 'Site Styles', icon: PaletteRoundedIcon },
  { key: BUILDER_SIDEBAR_VIEWS.TEMPLATES, label: 'Site Designs', icon: DashboardCustomizeRoundedIcon },
  { key: BUILDER_SIDEBAR_VIEWS.SETTINGS, label: 'Page Settings', icon: SettingsRoundedIcon },
];

export default function BuilderSidebar({
  activeView = BUILDER_SIDEBAR_VIEWS.ELEMENTS,
  onViewChange,
  title,
  subtitle,
  children,
}) {
  const activeItem = ITEMS.find((item) => item.key === activeView) || ITEMS[0];

  return (
    <Box className="ps-builder-sidebar ps-builder-sidebar--2026">
      <Box className="ps-builder-sidebar__rail" aria-label="Page editing tools">
        {ITEMS.map(({ key, label, icon: ItemIcon }) => {
          const active = key === activeView;
          return (
            <Tooltip key={key} title={label} placement="right">
              <IconButton
                aria-label={label}
                aria-pressed={active}
                className={`ps-builder-rail-button${active ? ' is-active' : ''}`}
                onClick={() => onViewChange?.(key)}
              >
                <ItemIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          );
        })}
      </Box>

      <Box className="ps-builder-sidebar__panel">
        <Box className="ps-builder-sidebar__header">
          <Typography className="ps-builder-panel-title">
            {title || activeItem.label}
          </Typography>
          {subtitle ? (
            <Typography variant="caption" className="ps-builder-panel-copy">
              {subtitle}
            </Typography>
          ) : null}
        </Box>
        <Box className="ps-builder-sidebar__content">{children}</Box>
      </Box>
    </Box>
  );
}
